import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
	selector: 'pcode-image-dialog',
	templateUrl: './image-dialog.component.html',
	styleUrls: ['./image-dialog.component.scss']
})
export class ImageDialogComponent
{
	// constructor
	constructor
		(
			private dialogRef: MatDialogRef<ImageDialogComponent>,
			@Inject(MAT_DIALOG_DATA) public imageData: string
		)
	{ }
}
